// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9d316aff","724":"3cf97f97"}[chunkId] + ".chunk.js";
};